<template>
  <div class="topbar d-flex align-items-center justify-content-between">
    <transition name="expand">
      <div v-if="showHamburger" class="hamburger-wrapper">
        <i class="pi pi-bars hamburger-toggle" @click="onMenuToggle"></i>
      </div>
    </transition>
    <span>
      <span class="fw-bold cursor-pointer" @click="$router.push('/')">RC STUDIO</span></span>
    <div class="d-flex align-items-center justify-content-end" style="width: 400px">
<!--       <div class="position-relative me-3 notification-bell-wrapper">
  <i class="pi pi-bell cursor-pointer " style="font-size: 1.5rem" @click="toggleNotifications($event)"></i>
  <span v-if="notifications.length > 0" class="notification-badge">{{ notifications.length }}</span>
  <OverlayPanel ref="op">
  <div class="flex flex-column gap-2 w-20rem">
    <div
      v-if="notifications.length === 0"
      class="p-2 border-round surface-100 text-center"
    >
    Non ci sono notifiche
    </div>
    <div
      v-for="notifica in notifications"
      :key="notifica.id"
      class="p-2 border-round surface-100 cursor-pointer hover:bg-primary-100"
      @click="markAsRead(notifica.id)"
    >
      <div class="fw-bold">{{ notifica.azione }}</div>
      <div class="text-sm">{{ notifica.dettaglioAzione }}</div>
      <div class="text-xs text-500 mt-1">{{ formatDate(notifica.data) }}</div>
    </div>
  </div>
</OverlayPanel>

</div>
 -->
      <InputText placeholder="Ricerca generale..." class="w-12 m-8" v-model="generalSearch" @keypress.enter="
        $router.push({ name: 'search', params: { query: generalSearch } })
        "></InputText>
      <span class="me-2" style="min-width: 140px">Ciao,
        <strong>{{ loggedUser.id ? loggedUser.nome : "User" }}</strong>
      </span>

      <div class="d-flex mr-2">
        <div class="grid-center">
          <Avatar v-if="loggedUser.imgprofilo" :image="loggedUser.imgprofilo"></Avatar>
          <Avatar v-else :label="loggedUser.id ? loggedUser.nome.slice(0, 1) : 'U'"></Avatar>
        </div>
        <Tag v-if="loggedUser.livelloLogin" :value="loggedUser.livelloLogin"
          style="border-top-left-radius: 0; border-bottom-left-radius: 0"></Tag>
      </div>

      <Button style="min-width: 70px" label="Logout" class="p-button-sm p-button-secondary" @click="logout"></Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import Avatar from "primevue/avatar";
import AxiosService from "@/axiosServices/AxiosService";
import { useStore } from "vuex";
import OverlayPanel from 'primevue/overlaypanel';
export default {
  props: {
    showHamburger: Number,
    OverlayPanel
  },
  created() {
    const store = useStore();

    setTimeout(() => {
      this.userVoip = store.getters["loggedUser"]
    }, 1000);
    this.getNoReadNotifications();
    //this.getAllNotifications();
  },

  data() {
    return {
      userVoip: null,
      generalSearch: null,
      notifications: [],
    };
  },
  methods: {
    async getNoReadNotifications() {
    try {
      const service = new AxiosService("Notifica/GetToRead");
      const res = await service.read();
      console.log('respueat', res)
      this.notifications = res;
    } catch (error) {
      console.error("Errore nel recupero notifiche:", error);
    }
  },
  async getAllNotifications() {
    try {
      const service = new AxiosService("Notifica/GetAll");
      const res = await service.read();
      this.notifications = res;
    } catch (error) {
      console.error("Errore nel recupero notifiche:", error);
    }
  },
  async markAsRead(id) {
    try {
      const service = new AxiosService('');
      await service.updateWithoutId(`Notifica/SetRead/${id}`);
      this.notifications = this.notifications.filter(n => n.id !== id);
    } catch (error) {
      console.error("Errore nel marcare la notifica come letta:", error);
    }
  },
  formatDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleString();
},

    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    toggleNotifications(event) {
    this.$refs.op.toggle(event);
  },
    logout: function () {
      const service = new AxiosService("Auth/Logout");
      service
        .create()
        .then((res) => console.log(res))
        .catch((err) => console.log(err));
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push("login");
      });
    },
  },
  
  computed: mapGetters(["loggedUser"]),
  components: { Avatar },
};
</script>

<style>
.hamburger-wrapper {
  overflow: hidden;
  width: 1.5rem;
  height: 100%;
  display: grid;
  place-content: center left;
}

.hamburger-toggle {
  cursor: pointer;
}

.expand-enter-active,
.expand-leave-active {
  transition-property: width, height;
  transition-duration: 0.4s;
  transition-timing-function: ease-out;
}

.expand-enter-from,
.expand-leave-to {
  width: 0px;
  height: 0px;
}
.notification-bell-wrapper {
  position: relative;
}

.notification-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: red;
  color: white;
  font-size: 0.55rem;
  padding: 2px 6px;
  border-radius: 50%;
  font-weight: bold;
  z-index: 10;
}

</style>
